import { Checkbox, FormControlLabel, Grid2, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  getDynamicMemberData,
  getDynamicMemberITINData,
} from "../../utils/constants";
import SelectInputTaxFilling from "./SelectInputTaxFilling";
import { StyledErrorMessage } from "../style/modalStyle";
import { Box } from "@mui/system";

const CorpData = ({
  formik,
  is_tax_free,
  showTotal,
  handleConsentChange,
  onTotalMembersChange,
  onTotalMembersITINChange,
}: {
  formik?: any;
  showTotal?: boolean;
  is_tax_free?: boolean;
  handleConsentChange?: any;
  onTotalMembersChange?: (data: any) => void;
  onTotalMembersITINChange?: (data: any) => void;
}) => {
  const [selectedMemberId, setSelectedMemberId] = useState<number | null>(null);
  const [selectedITINId, setSelectedITINId] = useState<number | null>(null);
  const [dynamicMemberData, setDynamicMemberData] = useState(
    getDynamicMemberData()
  );
  const [dynamicITINData, setDynamicITINData] = useState(
    getDynamicMemberITINData()
  );
  const baseTotal = 898.0;

  // Initialize selected values from formik if they exist
  useEffect(() => {
    if (formik?.values?.total_members) {
      const memberOption = dynamicMemberData.find(
        (item) => item.value === formik.values.total_members
      );
      if (memberOption) {
        setSelectedMemberId(memberOption.id);
      }
    }

    if (formik?.values?.total_members_itin) {
      const itinOption = dynamicITINData.find(
        (item) => item.value === formik.values.total_members_itin
      );
      if (itinOption) {
        setSelectedITINId(itinOption.id);
      }
    }
  }, [
    formik?.values?.total_members,
    formik?.values?.total_members_itin,
    dynamicMemberData,
    dynamicITINData,
  ]);

  useEffect(() => {
    setSelectedMemberId(null);
    setSelectedITINId(null);
  }, [formik?.values?.tax_filing]);

  const memberPrice = dynamicMemberData.find(
    (item) => item.id === selectedMemberId
  );
  const itinPrice = dynamicITINData.find((item) => item.id === selectedITINId);

  // Calculate total with selected prices
  const total = baseTotal + (memberPrice?.price || 0) + (itinPrice?.price || 0);
  // Update dynamic member data when selection changes
  useEffect(() => {
    setDynamicMemberData(getDynamicMemberData(selectedMemberId));
  }, [selectedMemberId]);
  console.log(dynamicMemberData, "dynamicMemberData");
  // Update dynamic ITIN data when selection changes
  useEffect(() => {
    setDynamicITINData(getDynamicMemberITINData(selectedITINId));
  }, [selectedITINId]);

  const handleMemberChange = (e: any) => {
    const selectedValue = e.target.value;
    console.log(selectedValue, "selectedVffffalue");

    // Find the selected option from the current dynamic data
    const selectedOption = dynamicMemberData.find(
      (item) => item.value === selectedValue
    );
    console.log(selectedOption, "selectedOption");

    if (selectedOption) {
      setSelectedMemberId(selectedOption.id);
      // Use original price for total calculation (not the display price)
      // setSelectedMemberPrice(selectedOption.price || 0);
      // Update formik value
      if (formik) {
        formik.setFieldValue("total_members", selectedOption.name);
      }
      // Pass the total_members data to parent component
      if (onTotalMembersChange) {
        onTotalMembersChange({
          value: selectedValue,
          option: selectedOption,
          price: selectedOption.price || 0,
        });
      }
    }
  };

  const handleITINChange = (e: any) => {
    const selectedValue = e.target.value;

    console.log(selectedValue, "selectedValue");

    // Find the selected option from the current dynamic data
    const selectedOption = dynamicITINData.find(
      (item) => item.value === selectedValue
    );
    console.log(selectedOption, "selectedOption");

    if (selectedOption) {
      setSelectedITINId(selectedOption.id);
      // Use original price for total calculation (not the display price)
      // setSelectedITINPrice(selectedOption.price || 0);
      // Update formik value
      if (formik) {
        formik.setFieldValue("total_members_itin", selectedOption.name);
      }
      // Pass the total_members_itin data to parent component
      if (onTotalMembersITINChange) {
        onTotalMembersITINChange({
          value: selectedValue,
          option: selectedOption,
          price: selectedOption.price || 0,
        });
      }
    }
  };
  useEffect(() => {
    formik.setFieldValue("total_amount", total);
  }, [total]);
  const handleConsentChangeLocal = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (formik) {
      formik.setFieldValue("consent", e.target.checked);
    }
  };

  return (
    <>
      <Grid2
        size={{ xs: 12, md: 7 }}
        sx={
          {
            // marginTop: "10px",
          }
        }
      >
        <SelectInputTaxFilling
          formik={formik}
          placeholder="LLC"
          label="Number of total members?*"
          menuData={dynamicMemberData}
          name="total_members"
          disabled={false}
          handleCustomData={handleMemberChange}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 7 }} sx={{ marginBottom: "4px" }}>
        <SelectInputTaxFilling
          formik={formik}
          placeholder="LLC"
          label="Do the members all have an ITIN?*"
          menuData={dynamicITINData}
          name="total_members_itin"
          disabled={false}
          handleCustomData={handleITINChange}
        />
      </Grid2>
      {showTotal && (
       <Box sx={{ width: "100%" }}>
          {/* <Grid2
            size={{ xs: 12, md: 12 }}
            sx={{
              marginBottom: "10px",
            }}
          >
            {" "}
            <Typography
              variant="h4"
              sx={{
                whiteSpace: "nowrap",
                fontSize: "18px",
                fontWeight: 600,
                color: "#060110",
              }}
            >
              Consent <span style={{ color: "#ff0000" }}>*</span>
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleConsentChangeLocal}
                  checked={formik?.values?.consent || false}
                />
              }
              label={
                <>
                  I agree to the{" "}
                  <span
                    style={{
                      color: "#2977CC",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // 🧠 Prevent checkbox toggle
                      window.open(
                        "https://theitin.com/privacy-policy/",
                        "_blank"
                      );
                    }}
                  >
                    privacy policy
                  </span>
                  .
                </>
              }
            />
            <StyledErrorMessage>
              {formik?.errors.consent &&
                (formik?.touched.consent || formik?.submitCount > 0) &&
                formik?.errors.consent}
            </StyledErrorMessage>
          </Grid2> */}

          <Typography
            variant="h4"
            sx={{
              whiteSpace: "nowrap",
              fontSize: "18px",
              fontWeight: 600,
              color: "#060110",
              marginTop: "20px",
            }}
          >
            Total{" "}
            <span
              style={{
                color: is_tax_free ? "#999" : "#2977CC",
                fontWeight: 600,
                fontSize: "20px",
                paddingLeft: 4,
                textDecoration: is_tax_free ? "line-through" : "none",
              }}
            >
              ${total.toFixed(2)}
            </span>
            {is_tax_free && (
              <span
                style={{
                  color: "#2977CC",
                  fontWeight: 600,
                  fontSize: "20px",
                  paddingLeft: 8,
                }}
              >
                $0
              </span>
            )}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default CorpData;
